import { StaticImage } from "gatsby-plugin-image";
import * as React from "react";
import Layout from "../../../components/Layout/Layout";
import Therapist from "../../../components/Therapist/Therapist";

// markup
const name = "Michelle VanDenHul";

const license = "MSW, CSW-PIP";
const areas = [
  "Childrens Ages (2-8 yrs)",
  "Trauma",
  "Abuse & Neglect",
  "Behavioral Issues",
  "Developmental Delays",
  "Grief",
  "Anxiety",
  "ADD/ADHD",
  "Depression",
  "Self-Esteem",
  "Life Transitions",
  "Adoption",
];

const IndexPage = () => (
  <Layout full={true} removeTopSpace={true} className="bg-yellow-50">
    <Therapist
      name={name}
      license={license}
      areas={areas}
      photo={
        <StaticImage
          src="./michelle-vandenhul-2.jpg"
          alt={name}
          layout="constrained"
          className="shadow"
          width={278}
        />
      }
      additionalLicense="Registered Play Therapist"
    >
      <p>
        <strong>Michelle VanDenHul, MSW, CSW, QMHP, RPT-S</strong>
      </p>

      <p>
        Michelle VanDenHul is a licensed Certified Social Worker and Qualified
        Mental Health Professional in private practice since 2009. She is also a
        Registered Play Therapist and Registered Play Therapy Supervisor.
        Michelle earned both her Bachelor's and Master's degrees in Social Work
        from the University of North Dakota.
      </p>

      <p>
        Prior to entering private practice, Michelle served as the Clinical
        Director of Children's Services for a community mental health agency,
        where she provided leadership and clinical oversight for children's
        programming. Throughout her career, her professional focus has remained
        centered on serving children and strengthening families.
      </p>

      <p>
        Michelle primarily works with children ages two through eight,
        collaborating closely with parents and caregivers to ensure that each
        child's emotional and developmental needs are thoughtfully addressed.
        She has extensive experience supporting children who have experienced
        trauma related to abuse and neglect, as well as those facing behavioral
        challenges, grief, anxiety, depression, self-esteem concerns, divorce,
        and ADD/ADHD.
      </p>

      <p>
        Michelle is an adoption-informed trained mental health therapist through
        the Center for Adoption.
      </p>

      <p>
        Trained extensively, in play therapy Michelle utilizes play therapy
        interventions to help children communicate, process emotions, and
        develop healthy coping skills. Through a compassionate and therapeutic
        approach, she provides a safe environment where children can heal, grow,
        and build resilience.
      </p>

      <p>
        <em>"Play is the work of the child"</em> — Maria Montessori
      </p>
      {/* <div className="flex flex-col sm:flex-row items-center justify-center gap-4 xl:gap-8 mt-8">
        <div className="w-full sm:w-1/3">
          <StaticImage
            src="../../../images/IMG_5125.JPEG"
            alt={name}
            layout="constrained"
            width={300}
            className="shadow"
          />
        </div>
        <div className="w-full sm:w-1/3">
          <StaticImage
            src="../../../images/IMG_5122.JPEG"
            alt={name}
            layout="constrained"
            width={300}
            className="shadow"
          />
        </div>
      </div> */}
    </Therapist>
  </Layout>
);

export default IndexPage;
